import React, { useState } from 'react';
import { formatDate } from '../../utils/datetime';

const BranchForm = ({ branch, loading, dataErrors, onSave, onCancel }) => {
  const [formData, setFormData] = useState({
    id: branch?.id || 0,
    branch_code: branch?.branch_code,
    name: branch?.name || '',
    contact_name: branch?.contact_name || '',
    contact_number: branch?.contact_number || '',
    email: branch?.email || '',
    address_line_1: branch?.address_line_1 || '',
    address_line_2: branch?.address_line_2 || '',
    city: branch?.city || '',
    state: branch?.state || '',
    pincode: branch?.pincode || '',
    gst_number: branch?.gst_number || '',
    latitude: branch?.latitude || '',
    longitude: branch?.longitude || '',
    is_active: branch?.is_active || 1,
  });

  const [validationErrors, setValidationErrors] = useState({});

  const handleChange = (e) => {
    const { name } = e.target;
    let { value } = e.target;
    if (name === 'contact_number') {
      value = value.replace(/\D/g, '').slice(0, 10);
    } else if (name === 'pincode') {
      value = value.replace(/\D/g, '').slice(0, 6);
    } else if ([
      'name',
      'contact_name',
      'email',
      'address_line_1',
      'address_line_2',
      'city',
      'state',
      'gst_number',
      'latitude',
      'longitude',
    ].includes(name)) {
      value = value.toUpperCase();
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = 'Name is required';
    if (!formData.contact_name) newErrors.contact_name = 'Contact Name is required';
    if (!formData.contact_number) newErrors.contact_number = 'Phone is required';
    if (!/^\d{10}$/.test(formData.contact_number)) newErrors.contact_number = 'Invalid phone number';
    if (!formData.email) newErrors.email = 'Email is required';
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)) newErrors.email = 'Invalid email';
    if (!formData.address_line_1) newErrors.address_line_1 = 'Address Line 1 is required';
    if (!formData.city) newErrors.city = 'City is required';
    if (!formData.state) newErrors.state = 'State is required';
    if (!/^\d{6}$/.test(formData.pincode)) newErrors.pincode = 'Pincode is required';
    if (
        formData.gst_number &&
        !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{3}$/i.test(
          formData.gst_number
        )
      )
        newErrors.gst_number = "Invalid GST number";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setValidationErrors([]);
    const errors = validate();
    if (Object.keys(errors).length) {
      setValidationErrors(errors);
      return;
    }
    onSave(formData);
  };

  const renderInput = (label, name, type = 'text') => (
    <div className="w-full">
      <label className="block text-sm font-medium mb-1">{label}</label>
      <input
        type={type}
        name={name}
        value={formData[name]}
        onChange={handleChange}
        className="w-full px-3 py-2 border rounded"
      />
      {validationErrors[name] && <p className="text-red-500 text-xs">{validationErrors[name]}</p>}
      {dataErrors[name] && <p className="text-red-500 text-sm mt-1">{dataErrors[name][0]}</p>}
    </div>
  );

  return (
    <div className="p-4 max-4 bg-white shadow rounded">
      {/* <h2 className="text-xl font-bold mb-6">{formData.id ? 'Edit' : 'Create'} Branch</h2> */}

      <form onSubmit={handleSubmit} className="space-y-8 [&_input[type='text']]:uppercase [&_input:disabled]:uppercase [&_select]:uppercase">

        {/* Section 1: Contact Details */}
        <section>
          <h3 className="text-lg font-semibold mb-2">Contact Details</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {renderInput('Name', 'name')}
            {renderInput('Contact Name', 'contact_name')}
            {renderInput('Contact Number', 'contact_number')}
            {renderInput('Email', 'email', 'email')}
          </div>
        </section>

        {/* Section 2: Address */}
        <section>
          <h3 className="text-lg font-semibold mb-2">Address</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {renderInput('Address Line 1', 'address_line_1')}
            {renderInput('Address Line 2', 'address_line_2')}
            {renderInput('City', 'city')}
            {renderInput('State', 'state')}
            {renderInput('Pincode', 'pincode')}
          </div>
        </section>

        {/* Section 3: Other Details */}
        <section>
          <h3 className="text-lg font-semibold mb-2">Other Details</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {renderInput('Latitude', 'latitude')}
            {renderInput('Longitude', 'longitude')}
            {renderInput('GST Number', 'gst_number')}
          </div>
        </section>

        {/* Actions */}
        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 border rounded text-sm hover:bg-gray-100"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={loading}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
          >
            {loading ? 'Saving...' : formData.id ? 'Update' : 'Create'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default BranchForm;
